<!-- <div #editorContainer id="custom-quill-editor" class="editor-container"></div> -->
<quill-editor
  [modules]="modules"
  [theme]="'snow'"
  (onEditorCreated)="EditorCreated($event)"
  (onContentChanged)="handleContentChange($event)"
></quill-editor>
